import angular from 'angular';
import { sqScatterConditionStore } from '@/hybrid/tools/scatterPlotSelection/scatterCondition.store';
import { ScatterConditionActions } from '@/hybrid/tools/scatterPlotSelection/scatterCondition.actions';

angular
  .module('Sq.Investigate')
  .store('sqScatterConditionStore', sqScatterConditionStore)
  .service('sqScatterConditionActions', ScatterConditionActions);
